import * as React from 'react';
import TotalReviewRating from 'PyzShopUi/scripts/product-review/components/total-review-rating/TotalReviewRating';
import {
    IProductReviewActionState,
    IReviewSummary
} from 'PyzShopUi/scripts/product-review/interfaces';
import { useEnhancedReducer } from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';
import { productReviewReducer } from 'PyzShopUi/scripts/product-review/reducer';
import { initProductReviewState } from 'PyzShopUi/scripts/product-review/actions/getReview';
import ProductReviewList from 'PyzShopUi/scripts/product-review/components/product-review-list/ProductReviewList';
import SortFilterSidebar
    from 'PyzShopUi/scripts/product-review/components/product-review-list/common/SortFilterSidebar';
import useApiQueryDataUpdate from 'PyzShopUi/scripts/product-review/hooks/useApiQueryDataUpdate';

interface IProductReviewProps {
    reviewSummary: IReviewSummary;
    abstractSku: string;
}

const emptyProductReviewListState: IProductReviewActionState = {
    sort: {
        sortParamNames: [],
        currentSortParam: null,
    },
    productReviews: [],
    ratingStars: [],
    filters: [],
    isPageLoading: true,
    apiQueryData: undefined,
    pagination: {
        numFound: 0,
        currentPage: 1,
        maxPage: 1,
        currentItemsPerPage: 0,
        config: {
            defaultItemsPerPage: 48,
            validItemsPerPageOptions: [],
        },
    },
};

const ProductReview: React.FunctionComponent<IProductReviewProps> = props => {
    const { reviewSummary, abstractSku } = props;

    const { averageRating, reviewCount } = reviewSummary;

    const [state, dispatch] = useEnhancedReducer(productReviewReducer, emptyProductReviewListState);

    const {
        pagination,
        productReviews,
        ratingStars,
        sort,
        isPageLoading,
        apiQueryData,
        filters
    } = state;

    const currentPage: number = pagination?.currentPage || 0;
    const maxPage: number = pagination?.maxPage || 0;

    useApiQueryDataUpdate(apiQueryData, dispatch);

    React.useEffect(() => {
        dispatch(initProductReviewState(abstractSku));
    }, []);

    return (
        <div className="grid-x grid-padding-x">
            <div className="cell small-12 medium-4">
                <TotalReviewRating
                    reviewCount={reviewCount}
                    averageRating={averageRating}
                    ratingStars={ratingStars}
                    dispatch={dispatch}
                />
            </div>

            <div className="cell small-12 medium-4 large-3 show-for-small-only">
                <SortFilterSidebar
                    pagination={pagination}
                    sort={sort}
                    isProgressing={isPageLoading}
                    dispatch={dispatch}
                    filters={filters}
                    ratingStars={ratingStars}
                />
            </div>

            <div className="cell small-12 medium-8">
                <ProductReviewList
                    isProgressing={isPageLoading}
                    sort={sort}
                    productReviews={productReviews}
                    dispatch={dispatch}
                    currentPage={currentPage}
                    maxPage={maxPage}
                    filters={filters}
                    apiQueries={apiQueryData}
                />
            </div>
        </div>
    );
};

export default ProductReview;
